module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: " weex-ct weex-div",
    staticStyle: {
      "width": "10rem",
      "-webkit-box-align": "center",
      "-webkit-align-items": "center",
      "align-items": "center",
      "background-color": "#fff"
    },
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: "dof-simple-rich-text weex-ct weex-div",
    staticStyle: {
      "-webkit-flex-wrap": "wrap",
      "flex-wrap": "wrap",
      "-webkit-box-flex": "1",
      "-webkit-flex": "1",
      "flex": "1",
      "-webkit-box-orient": "horizontal",
      "-webkit-box-direction": "normal",
      "-webkit-flex-direction": "row",
      "flex-direction": "row",
      "background-color": "#ffffff"
    },
    style: ({
      width: _vm._px2rem(_vm.RichTextwidth + 'px', 75)
    }),
    attrs: {
      "weex-type": "div"
    }
  }, _vm._l((_vm.data), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "textItem weex-ct weex-div",
      attrs: {
        "weex-type": "div"
      }
    }, [_c('p', {
      staticClass: " weex-el weex-text",
      class: ['textContent', _vm.hasNumOrEn(item.content) ? '' : 'hasNumOrEn'],
      style: ({
        color: item.color,
        fontSize: _vm._px2rem(item.size + 'px', 75)
      }),
      attrs: {
        "weex-type": "text"
      }
    }, [_vm._v(_vm._s(item.content))])])
  }), 0)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1ee503de", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ee503de","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-simple-rich-text/index.vue
// module id = 573
// module chunks = 0 1